export const getCollectionPuzzles = require("./getCollectionPuzzles").getCollectionPuzzles
export const getPuzzleForAdmin = require("./getPuzzleForAdmin").getPuzzleForAdmin
export const editPuzzleForAdmin = require("./editPuzzleForAdmin").editPuzzleForAdmin
export const deletePuzzleForAdmin = require("./deletePuzzleForAdmin").deletePuzzleForAdmin
export const approvePuzzle = require("./approvePuzzle").approvePuzzle
export const rejectPuzzle = require("./rejectPuzzle").rejectPuzzle
export const activatePuzzle = require("./activatePuzzle").activatePuzzle
